import { render, staticRenderFns } from "./ContactoComponent.vue?vue&type=template&id=b52580b8&scoped=true"
import script from "./ContactoComponent.vue?vue&type=script&lang=js"
export * from "./ContactoComponent.vue?vue&type=script&lang=js"
import style0 from "./ContactoComponent.vue?vue&type=style&index=0&id=b52580b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52580b8",
  null
  
)

export default component.exports